<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="py-2">
      <b-link
        class="text-decoration-none d-flex align-items-center opacity-50"
        to="/messages"
      >
        <b-icon icon="arrow-left" />
        <span class="mx-1 text-caption font-weight-semibold text-black">
          All Messages
        </span>
      </b-link>
    </div>
    <b-button
      v-if="showAddControl"
      variant="warning"
      class="text-body1 font-weight-semibold text-decoration-none text-black"
      to="/messages/distribution-list/add"
    >
      <span class="vertical-middle mr-1">
        <b-icon icon="plus-circle" scale="0.8" />
      </span>
      Add Distribution List
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'DistributionListHeader',
  props: {
    showAddControl: { type: Boolean },
  },
};
</script>
